import React, { useState } from "react";
import { Container, Row, Col, ListGroup, Tab, Nav } from "react-bootstrap";
import Card from "../../components/Card";
import { Link, useLocation } from "react-router-dom";
import Chart from "react-apexcharts";
import { get_my_task_report_bystatus } from "../../services/employeeApi";
import { formatDate } from "../../utils/date_utils";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import CustomPagination from "../../utils/CustomPagination";
import { GetUserInfo } from "../../utils/permissionChecker";
const Taskview = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const emp_id = user.employee.id;
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const maxVisiblePages = 5;
  const task_detailQuery = useQuery(["my_task_status_report"], () =>
    get_my_task_report_bystatus(emp_id)
  );

  if (task_detailQuery.isLoading) {
    return <div>Loading...</div>;
  }
  if (task_detailQuery.isError) {
    return <div>Error: {task_detailQuery.error.message}</div>;
  }

  const task_detail = task_detailQuery.data;

  const totalPages = 4;
  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1) {
      setCurrentPage(1);
    } else if (pageNumber > totalPages) {
      setCurrentPage(totalPages);
    } else {
      setCurrentPage(pageNumber);
    }
  };

  const chart1 = {
    series: [
      {
        data: [
          task_detail?.total_tasks,
          task_detail?.total_pending,
          task_detail?.total_approved,
          task_detail?.total_rejected,
        ],
      },
    ],
    options: {
      chart: {
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          columnWidth: "35%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: true, // show totals on top of bars
      },
      grid: {
        xaxis: { lines: { show: false } },
        yaxis: { lines: { show: true } },
      },
      legend: { show: false },
      yaxis: {
        labels: {
          offsetY: 0,
          minWidth: 20,
          maxWidth: 20,
        },
      },
      xaxis: {
        categories: ["Total", "Pending", "Approved", "Rejected"],
        labels: {
          style: { fontSize: "12px" },
        },
      },
      colors: ["#003ffbff", "#24d3f6ff", "#00fb15ff", "#f624bbff"], // different colors for bars
    },
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="12">
            <div className="d-flex flex-wrap align-items-center justify-content-between">
              <div className="d-flex align-items-center justify-content-between">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb p-0 mb-0">
                    <li className="breadcrumb-item">
                      <Link to="/my-tasks">{t("task")}</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {t("task_status")}
                    </li>
                  </ol>
                </nav>
              </div>
              <Link
                to="/my-tasks"
                className="btn btn-primary btn-sm d-flex align-items-center justify-content-between ml-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="ml-2">{t("back")}</span>
              </Link>
            </div>
          </Col>
          <Col lg="12" className="mb-3 d-flex justify-content-between">
            <h4 className="font-weight-bold d-flex align-items-center">
              {t("task_review")}
            </h4>
          </Col>
        </Row>

        <Row>
          <Col lg="4">
            <Card>
              <ListGroup as="ul" className="list-group-flush">
                <ListGroup.Item as="li">
                  <div>
                    <ListGroup as="ul" className="list-style-1 mb-0">
                      <ListGroup.Item
                        as="li"
                        className="d-flex justify-content-start align-items-center"
                      >
                        <div className="list-style-detail ml-4 mr-2">
                          <h5 className="font-weight-bold">
                            {user.employee.first_name}{" "}
                            {user.employee.father_name}
                          </h5>
                        </div>
                      </ListGroup.Item>
                    </ListGroup>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item as="li">
                  <table className="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td className="p-0">
                          <p className="mb-0 text-muted">{t("from_date")}</p>
                        </td>
                        <td>
                          <p className="mb-0 ">
                            {formatDate(task_detail?.start_date)}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td className="p-0">
                          <p className="mb-0 text-muted">{t("to_date")}</p>
                        </td>
                        <td>
                          <p className="mb-0 ">
                            {formatDate(task_detail?.end_date)}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ListGroup.Item>
                <ListGroup.Item as="li">
                  <h6 className="font-weight-bold">Task Report</h6>
                  <Chart
                    options={chart1.options}
                    series={chart1.series}
                    type="bar"
                    height="250px"
                  />
                </ListGroup.Item>
              </ListGroup>
            </Card>
          </Col>
          <Col lg="8">
            <Card>
              <Card.Body className="p-0">
                <Tab.Container defaultActiveKey="first">
                  <Nav as="ul" variant="nav tab-nav-pane nav-tabs pt-2 mb-0">
                    <Nav.Item as="li" className="pb-2 mb-0 nav-item">
                      <Nav.Link
                        data-toggle="tab"
                        eventKey="first"
                        bsPrefix="font-weight-bold px-5 py-2 "
                      >
                        {t("report_summery")}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" className="pb-2 mb-0 nav-item">
                      <Nav.Link
                        data-toggle="tab"
                        eventKey="second"
                        bsPrefix="font-weight-bold px-5 py-2"
                      >
                        {t("my_task_detail_report")}
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>

                  <Tab.Content>
                    <Tab.Pane eventKey="first" className=" fade show  ">
                      <div className="d-flex justify-content-between align-items-center p-3">
                        <h5>{t("task_list_by_status")}</h5>
                      </div>
                      <div className="table-responsive">
                        <table className="table data-table mb-0">
                          <thead className="table-color-heading">
                            <tr className="text-muted">
                              <th scope="col">Status</th>
                              <th scope="col">Tasks Count</th>
                              <th scope="col">Total Quantity</th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* Pending Status Row */}
                            <tr>
                              <td>
                                <p className="mb-0 text-warning d-flex justify-content-start align-items-center">
                                  <svg
                                    className="mr-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <circle
                                      cx="12"
                                      cy="12"
                                      r="8"
                                      fill="#ffc107"
                                    ></circle>
                                  </svg>
                                  Pending
                                </p>
                              </td>
                              <td>
                                {task_detail?.summary?.pending?.tasks_count}
                              </td>
                              <td>
                                {task_detail?.summary?.pending?.total_quantity}
                              </td>
                            </tr>

                            {/* Approved Status Row */}
                            <tr>
                              <td>
                                <p className="mb-0 text-success d-flex justify-content-start align-items-center">
                                  <svg
                                    className="mr-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <circle
                                      cx="12"
                                      cy="12"
                                      r="8"
                                      fill="#28a745"
                                    ></circle>
                                  </svg>
                                  Approved
                                </p>
                              </td>
                              <td>
                                {task_detail?.summary?.approved?.tasks_count}
                              </td>
                              <td>
                                {task_detail?.summary?.approved?.total_quantity}
                              </td>
                            </tr>

                            {/* Rejected Status Row (if any) */}
                            {task_detail.summary.rejected && (
                              <tr>
                                <td>
                                  <p className="mb-0 text-danger d-flex justify-content-start align-items-center">
                                    <svg
                                      className="mr-2"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <circle
                                        cx="12"
                                        cy="12"
                                        r="8"
                                        fill="#dc3545"
                                      ></circle>
                                    </svg>
                                    Rejected
                                  </p>
                                </td>
                                <td>
                                  {task_detail?.summary?.rejected?.tasks_count}
                                </td>
                                <td>
                                  {
                                    task_detail?.summary?.rejected
                                      ?.total_quantity
                                  }
                                </td>
                              </tr>
                            )}
                            {/* Totals Row */}
                            <tr className="table-active">
                              <td>
                                <strong>Total</strong>
                              </td>
                              <td>
                                <strong>{task_detail.total_tasks}</strong>
                              </td>
                              <td>
                                <strong>
                                  {task_detail?.summary?.pending
                                    ?.total_quantity +
                                    task_detail?.summary?.approved
                                      ?.total_quantity +
                                    (task_detail?.summary?.rejected
                                      ?.total_quantity || 0)}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second" className="  fade p-3">
                      <h3 className="mb-3">Task Detail</h3>

                      <div className="table-responsive">
                        <div className="table-responsive">
                          <table className="table data-table mb-0">
                            <thead className="table-color-heading">
                              <tr className="text-muted">
                                <th scope="col">#</th>
                                <th scope="col">Task ID</th>
                                <th scope="col">Date</th>
                                <th scope="col">Quantity</th>

                                <th scope="col">Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* Pending Tasks */}
                              {task_detail?.summary?.pending?.tasks.map(
                                (item, index) => (
                                  <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>{item.task_id}</td>
                                    <td>{item.date}</td>
                                    <td>{item.quantity}</td>

                                    <td>
                                      <p className="mb-0 text-warning d-flex justify-content-start align-items-center">
                                        <svg
                                          className="mr-2"
                                          width="18"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <circle
                                            cx="12"
                                            cy="12"
                                            r="8"
                                            fill="#ffc107"
                                          ></circle>
                                        </svg>
                                        Pending
                                      </p>
                                    </td>
                                  </tr>
                                )
                              )}

                              {/* Approved Tasks */}
                              {task_detail?.summary?.approved?.tasks.map(
                                (item, index) => (
                                  <tr key={item.id}>
                                    <td>
                                      {task_detail?.summary?.pending?.tasks
                                        .length +
                                        index +
                                        1}
                                    </td>
                                    <td>{item.task_id}</td>
                                    <td>{item.date}</td>
                                    <td>{item.quantity}</td>

                                    <td>
                                      <p className="mb-0 text-success d-flex justify-content-start align-items-center">
                                        <svg
                                          className="mr-2"
                                          width="18"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <circle
                                            cx="12"
                                            cy="12"
                                            r="8"
                                            fill="#28a745"
                                          ></circle>
                                        </svg>
                                        Approved
                                      </p>
                                    </td>
                                  </tr>
                                )
                              )}

                              {/* Rejected Tasks (if any) */}
                              {task_detail?.summary?.rejected &&
                                task_detail?.summary?.rejected?.tasks.map(
                                  (item, index) => (
                                    <tr key={item.id}>
                                      <td>
                                        {task_detail?.summary?.pending?.tasks
                                          .length +
                                          task_detail?.summary?.approved?.tasks
                                            .length +
                                          index +
                                          1}
                                      </td>
                                      <td>{item.task_id}</td>
                                      <td>{item.date}</td>
                                      <td>{item.quantity}</td>

                                      <td>
                                        <p className="mb-0 text-danger d-flex justify-content-start align-items-center">
                                          <svg
                                            className="mr-2"
                                            width="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <circle
                                              cx="12"
                                              cy="12"
                                              r="8"
                                              fill="#dc3545"
                                            ></circle>
                                          </svg>
                                          Rejected
                                        </p>
                                      </td>
                                    </tr>
                                  )
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default Taskview;
